import { livestreamStore } from '../../ng-services/livestreams/livestream.store';

export class HeroSwitcherComponent {
    state: 'hero' | 'livestream' = 'hero';

    get isHero() {
        return livestreamStore.active === null;
    }

    get isPlayingLivestream() {
        return livestreamStore.active !== null;
    }
}

angular.module('tradersyard').component('tyHeroSwitcher', {
    // language=HTML
    template: `
        <div mobx-autorun id="hero-switcher">
            <div ng-if="$ctrl.isHero">
                <ng-transclude/>
            </div>
            <div ng-if="$ctrl.isPlayingLivestream">
                <ty-livestream/>
            </div>
        </div>
    `,
    controller: HeroSwitcherComponent,
    transclude: true,
});
